import React, { useState, useRef, useEffect, useContext } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { Container, Grid, Paper, Divider } from '@material-ui/core';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { LOGOUT } from 'ConstComponents';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import {
    OTT,
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import { AutoCompleteTextView } from 'Components/Inputes/AutoCompleteTextView';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { Last10RechargeReportAPP } from 'Pages/InnerPages/Report/Last10RechargeReportApp';
import {
    SelectBundleOperator,
    SelectBundlePlan,
    BundlePayment
} from 'Components/Api/PaysprintOTTAPI';
import PayIcon from 'Components/SvgButtons/PayIcon';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { CONSUMER_NUMBER_FONT_SIZE } from 'Config';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import InputLabel from 'Components/Inputes/InputLabel';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { BalanceContext } from 'Components/BalanceContext';
import { CustomModalWithScroll } from 'Components/Modal/CustomModalWithScroll';
import ReactTable from 'Components/ReactTable/ReactTable';
import { MaterialConsumerNumber } from 'Components/Inputes/MaterialConsumerNumber';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
const CustomContainer = HOCLoader(Container);
export const OTTTransactionBundleAPP = (props) => {
    const { DashboardBalanceUpdate } = useContext(BalanceContext);
    const { OperatorID, setRefreshRandom } = props;
    const classes = commonStyle();
    const [consumerNumberFontSize, setConsumerNumberFontSize] = useState('');
    async function fetchConsumerNumberFontSize() {
        setConsumerNumberFontSize(await CONSUMER_NUMBER_FONT_SIZE());
    }
    const [responseMessage, setResponseMessage] = useState('');
    const history = useHistory();
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [confirmAlertMessage, setConfirmAlertMessage] = useState('');
    const [serviceCode, setserviceCode] = useState(OTT);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [status, setStatus] = useState('PROCESS');

    const [SubscriptionOperatorList, setSubscriptionOperator] = useState([]);
    const [Plan, setPlan] = useState([]);
    const [planColumns, setPlanColumns] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [description, setDescription] = useState('');

    const formRef = useRef();
    const [InWords, setInWords] = useState('');
    const [OperatorDefault, setOperatorDefault] = useState({
        operator_code: '',
        operator_name: 'Select Operator'
    });

    const initialValues = {
        ServiceID: OTT,
        OperatorID: OperatorID,
        Operator: OperatorDefault,
        Amount: 0,
        ConsumerNumber: '',
        EmailID: '',
        InWords: InWords
    };

    const [FormObj, setFormObj] = useState(initialValues);

    const FormValidationSchema = Yup.object({
        Operator: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator')
            .shape({
                operator_code: Yup.string().required(
                    PLEASE_SELECT_VALID + 'operator'
                )
            }),
        ConsumerNumber: Yup.string()
            .length(10, 'Must be 10 digit')
            .required(PLEASE_PROVIDE_VALID + 'number'),

        EmailID: Yup.string()
            .trim()
            .email()
            .required(PLEASE_PROVIDE_VALID + 'email address'),

        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(0, PLEASE_PROVIDE_VALID + 'amount')
    });

    const OnChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) return;
        setInWords(NumberToWord(value));
        setFieldValue('InWords', NumberToWord(value));
    };

    useEffect(() => {
        fetchConsumerNumberFontSize();
        selectOperator();
    }, []);

    const selectOperator = async () => {
        const response = await SelectBundleOperator();
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        var data = JSON.parse(response.data);
        setSubscriptionOperator(data);
    };
    const OnOperatorChange = async (name, value, setFieldValue) => {
        setOperatorDefault({
            operator_code: value.operator_code,
            operator_name: value.operator_name
        });

        setFieldValue(name, value);
        selectPlan(value.operator_code);
    };

    const selectPlan = async (operator_code) => {
        if (
            operator_code === null ||
            operator_code === undefined ||
            operator_code === '0'
        )
            return;

        var requestObj = {
            OperatorCode: operator_code
        };

        var request = JSON.stringify(requestObj);

        const response = await SelectBundlePlan(request);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        var data = JSON.parse(response.data);
        CreatePlanColumns();
        setIsOpen(true);
        setPlan(data);
    };

    const CreatePlanColumns = () => {
        var columns = [];
        columns.push({
            label: '',
            name: '',
            buttonTitle: 'Buy this plan',
            buyButton: true,

            callback: (row) => {
                if (formRef.current)
                    formRef.current.setFieldValue('Amount', row[1]);
                formRef.current.setFieldValue('PlanID', row[5]);
                setDescription('duration : ' + row[2] + ' \n plan: ' + row[3]);
                setIsOpen(false);
            }
        });
        columns.push({
            label: 'RS',
            name: 'amount',
            draggle: true
        });

        columns.push({
            label: 'duration',
            name: 'duration',
            draggle: true
        });
        columns.push({
            label: 'planCode',
            name: 'planCode'
        });

        columns.push({
            label: 'duration days',
            name: 'duration_in_days'
        });

        columns.push({
            label: 'plan_id',
            name: 'plan_id',
            hide: true
        });

        setPlanColumns(columns);
    };

    const submitHandle = async (values) => {
        setResponseMessage('');
        setIsError(false);

        var RequestObj = {
            ServiceID: OTT,
            OperatorID: OperatorID,
            OperatorName: values.Operator.operator_name,
            SubscriptionOperatorID: values.Operator.operator_code,
            InWords: values.InWords,
            ConsumerNumber: values.ConsumerNumber,
            EmailID: values.EmailID,
            PlanID: values.PlanID,
            Amount: values.Amount
        };

        let msg = '';

        msg = `Please confirm plan - \n\n : ${values.Amount}`;

        setConfirmAlertMessage(msg);
        setConfirmAlertRequest(RequestObj);
        setIsAlertOpen(true);
    };

    const Payment = async () => {
        setResponseMessage('');
        setIsError(false);

        var requestObj = JSON.stringify(confirmAlertRequest);

        setLoading(true);

        var response = await BundlePayment(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        let dataSuccess = JSON.parse(response.data);

        setSeverity('success');
        setResponseMessage(dataSuccess.Message);
        setIsError(true);

        setStatus(dataSuccess.Status);
        setResponseAlert(dataSuccess);
        setIsResponseAlertOpen(true);

        await DashboardBalanceUpdate();

        reset();
    };

    const reset = () => {
        setFormObj({
            ServiceID: OTT,
            OperatorID: OperatorID,
            AccountNo: '',
            IFSC: '',
            Amount: '',
            UPIID: '',
            InWords: '',
            BeneName: ''
        });
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={FormObj}
            >
                {({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AutoCompleteTextView
                                                        }
                                                        defaultValue={
                                                            OperatorDefault
                                                        }
                                                        FieldName="Operator"
                                                        name="Operator"
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            OnOperatorChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                        options={
                                                            SubscriptionOperatorList
                                                        }
                                                        getOptionLabel={(
                                                            option
                                                        ) =>
                                                            option.operator_name
                                                        }
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.operator_name ===
                                                            value.operator_name
                                                        }
                                                        textFieldProps={{
                                                            label:
                                                                'Bundle Operator'
                                                        }}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialCurrency
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        name="Amount"
                                                        label="Amount"
                                                        placeholder="Amount"
                                                        autoComplete="new-password"
                                                        size="small"
                                                        max={10000}
                                                        title="Amount"
                                                        onCustomCallback={(
                                                            value
                                                        ) => {
                                                            OnChange(
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                    />
                                                    <InputLabel
                                                        color="green"
                                                        value={InWords}
                                                    />
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialConsumerNumber
                                                        font_size={
                                                            consumerNumberFontSize
                                                        }
                                                        label="Consumer Number"
                                                        name="ConsumerNumber"
                                                        icon="mobile"
                                                        length="10"
                                                        placeholder="Consumer Number"
                                                        title="Consumer Number"
                                                        typed_length={1}
                                                    />
                                                </Grid>

                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <MaterialTextField
                                                        label="EmailID"
                                                        name="EmailID"
                                                        type="text"
                                                        placeholder="EmailID"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Divider
                                                variant="middle"
                                                className="rechdevider"
                                            />

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                spacing={2}
                                                container
                                                className={classes.footerGrid}
                                            >
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={6}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <SecondaryButton
                                                        type="reset"
                                                        variant="contained"
                                                        color="secondary"
                                                        title="Reset"
                                                        disabled={loading}
                                                        endIcon={<ResetIcon />}
                                                        onClick={(e) => reset()}
                                                    ></SecondaryButton>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={6}
                                                    sm={6}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="Payment"
                                                        endIcon={<PayIcon />}
                                                        disabled={loading}
                                                        onClick={(e) => {}}
                                                    ></PrimaryButton>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Form>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={6}
                                lg={8}
                                className="lastrecharges"
                            >
                                <Last10RechargeReportAPP
                                    ServiceID={serviceCode}
                                    refreshRandom={1}
                                />
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isOpen ? (
                <CustomModalWithScroll
                    isOpen={isOpen}
                    title="Plan"
                    width="75vw"
                    onDismissCallback={(value) => {
                        setIsOpen(value);
                    }}
                >
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <ReactTable
                            data={Plan}
                            columns={planColumns}
                            rowsPerPage={10}
                            headerToolbar={false}
                        />
                    </Grid>
                </CustomModalWithScroll>
            ) : null}

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="OTT Confirmation"
                    message={confirmAlertMessage}
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        Payment(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    isPrint={true}
                    title={status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                    PrintButtonClick={() => {
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
